import * as React from 'react';
import styled from 'styled-components';
import VideoPlayCircle from 'icons/VideoPlayCircle';
import {transition} from 'helpers/css';

const Label = styled.div`
  white-space: nowrap;
  width: max-content;
  margin: 0;
  max-width: 0;
  overflow: hidden;
  ${transition()}
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  border-radius: 100px;
  background: transparent;
  cursor: pointer;

  ${transition()}

  &:hover {
    background: ${({theme}) => `
     ${theme.variables.accentColor};
   `};
    
    ${Label} {
      max-width: 280px;
      margin-left: 30px;
      margin-right: 15px;
    }
  }

  @media screen and (max-width: 580px) {
    &:hover {
      ${Label} {
        max-width: 0;
        margin: 0;
      }
    }
  }
`;


/**
 * The button watch video component
 * @param {any} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function ButtonVideo(
    props: any,
): React.ReactElement {
  return (
    <Container>
      <Label>Смотреть видео о курсе</Label>
      <VideoPlayCircle />
    </Container>
  );
}
